import { useQuery } from "@apollo/client/react";
import { GET_FILTER_OPTIONS } from "../graphql/queries";

const useFilterOptions = () => {
  const { data, loading, error } = useQuery(GET_FILTER_OPTIONS);
  return {
    kamNames: data?.kamNames ?? [],
    loading,
    error,
  };
};

export default useFilterOptions;
